export default {
    NO_ITEM_SELECTED: 'No has seleccionado un elemento para encantar.',
    CANNOT_ENCHANT: 'El elemento que has seleccionado no se puede encantar.',
    NO_SHARD: 'Debes proporcionar un fragmento para encantar un objeto.',
    FAILED_ENCHANT: 'Intentaste encantar pero no pasó nada.',
    SUCCESSFUL_ENCHANT: 'Encantaste con éxito tu objeto.'
} as const;
